"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../utils");
var decode_1 = __importDefault(require("./decode"));
var encode_1 = __importDefault(require("./encode"));
var Transparent48 = /** @class */ (function () {
    function Transparent48(virtual) {
        this.frameTypes = {
            appSend: 7,
            appSendResp: 8,
            devAuth: 3,
            devAuthResp: 4,
            devLogin: 1,
            devLoginResp: 2,
            devReport: 5,
            devReportResp: 6,
            devSend: 9,
            devSendResp: 10,
            heartbeat: 11,
            heartbeatResp: 12
        };
        this.virtual = virtual;
    }
    Transparent48.prototype.send = function (action, data) {
        if (data === void 0) { data = {}; }
        var frameType = this.frameTypes[action];
        if (frameType) {
            var raw = this.encode(frameType, data);
            if (raw && raw.length > 2) {
                this.virtual.emit('send', {
                    action: action,
                    raw: raw
                });
                this.virtual.webSocket.send(raw);
            }
            else {
                console.error(action + "\uFF1A\u5E27\u5185\u5BB9\u7F16\u7801\u9519\u8BEF\uFF0C" + JSON.stringify(data));
            }
        }
    };
    Transparent48.prototype.receive = function (raw) {
        var _this = this;
        var frameType = utils_1.hexToDec(raw.slice(4, 6));
        var action = utils_1.find(Object.keys(this.frameTypes), function (key) { return _this.frameTypes[key] === frameType; });
        if (action) {
            this.virtual.emit('receive', {
                action: action,
                raw: raw
            });
            this.decode(raw);
        }
    };
    Transparent48.prototype.decode = function (raw) {
        decode_1.default(this)(raw);
    };
    Transparent48.prototype.encode = function (frameType, data) {
        return encode_1.default(this)(frameType, data);
    };
    return Transparent48;
}());
exports.default = Transparent48;



// WEBPACK FOOTER //
// ./src/transparent48/index.ts